// 对于 handler 相关的处理，避免多次不必要的 handler function 更新
import { useCallback, useLayoutEffect, useRef } from 'react';

export default function useEvent(handler) {
	const handlerRef = useRef(null);

	// 视图渲染完成后更新
	useLayoutEffect(() => {
		handlerRef.current = handler;
	});

	return useCallback((...args) => {
		const fn = handlerRef.current;
		return fn?.(...args);
	}, []);
}
